import { useEffect, useContext } from 'react'
import { AdminContext } from 'context/AdminContext'

import ScreenFrame from 'components/Frame/ScreenFrame'
import TabSelector from 'components/Tabs/TabSelector'
import UserDirectoryFilters from 'components/UserDirectory/UserDirectoryFilters'
import UserDirectoryExports from 'components/UserDirectory/UserDirectoryExports'
import SelectedUserDirectoryUser from 'components/UserDirectory/SelectedUserDirectoryUser'
import PaginationController from 'components/Pagination/PaginationController'
import UserDirectoryTable from 'components/UserDirectory/UserDirectoryTable'

export default function UserDirectory() {

    const { UserDirectorySubContext } = useContext(AdminContext)
    const { userDirectoryPagination, setUserDirectoryPagination } = UserDirectorySubContext

    const HandleTabChange = (tabKey) => {
        UserDirectorySubContext.setUserDirectoryFilters({})
        UserDirectorySubContext.setSelectedTabKey(tabKey)
    }

    useEffect(() => {
        const abortController = new AbortController()

        UserDirectorySubContext.GetUserDirectory(abortController)
        
        return () => { 
            abortController.abort() 
        }
    }, [UserDirectorySubContext.userDirectoryFilters, userDirectoryPagination.page])

    return (
        <ScreenFrame limitWidth={false}>
            <div className='flex items-center gap-x-4'>
                <h1 className="pt-2 text-2xl font-semibold text-gray-900 tracking-tight flex-grow">
                    Users
                </h1>

                <TabSelector 
                    tabs={UserDirectorySubContext.userDirectoryTabs} 
                    selectedTabKey={UserDirectorySubContext.selectedTabKey} 
                    HandleTabChange={HandleTabChange} 
                />
            </div>

            <UserDirectoryFilters />

            <UserDirectoryExports />

            {UserDirectorySubContext.selectedTabKey === 'user-info' && <SelectedUserDirectoryUser />}

            <PaginationController pagination={userDirectoryPagination} setPagination={setUserDirectoryPagination} />

            {UserDirectorySubContext.userDirectory === null &&
                <>
                    <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                    <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                    <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                </>
            }

            {UserDirectorySubContext.userDirectory !== null && UserDirectorySubContext.userDirectory?.length > 0 && (
                <UserDirectoryTable />
            )}
        </ScreenFrame>
    )
}
